import { palette, Typography } from "@powerdiary/components-library/lib";
import ConnectionTestSection from "../ConnectionTestSection";
import styles from "./TelehealthRoomNotReady.module.css";
import { Box, Button, Card, Divider } from "@mui/material";

const TelehealthRoomNotReady = () => {
    const notExpectedYetMessage = "Sorry - we're not expecting you just yet!";

    return (
        <Card variant="elevation" raised={true} className={styles.roomNotReady} data-test-id="card_room_not_ready">
            <Box
                display="flex"
                flexDirection="column"
                gap="16px"
                textAlign="center"
                marginBottom="32px"
                alignItems="center"
            >
                <Typography
                    variant="paragraphExtraLargeRegular"
                    color={palette.neutral["700"]}
                    data-test-id="text_not_expected_yet"
                >
                    {notExpectedYetMessage}
                </Typography>
                <Typography
                    variant="paragraphExtraLargeRegular"
                    color={palette.neutral["700"]}
                    data-test-id="text_room_open_shortly"
                >
                    The waiting room will open 30 minutes before your appointment.
                </Typography>
                <Button
                    variant="contained"
                    sx={{ width: "auto" }}
                    data-test-id="button_check_again_availability"
                    onClick={() => {
                        location.reload();
                    }}
                >
                    Check again
                </Button>
            </Box>
            <Box display="flex" flexDirection="column" gap="32px">
                <Divider />

                <Box textAlign="center">
                    <ConnectionTestSection />
                </Box>
            </Box>
        </Card>
    );
};

export default TelehealthRoomNotReady;
